//libs
//types
import { Marker } from "@react-google-maps/api";
import { faCircle } from "@fortawesome/free-solid-svg-icons";

//interface
type Props = {
    lat: number;
    lng: number;
};

//Component
const TravelUrbanSharingMarkerPointA = ({ lat, lng }: Props) => {

    return <Marker
        position={{ lat, lng }}
        draggable={true}
        // onDragEnd={(evt) => props.onGoogleMarkerDestinyDragend({ latLng: evt.latLng! })}
        icon={{
            path: faCircle.icon[4] as string,
            fillColor: "#3983fbff",
            fillOpacity: 1,
            anchor: new google.maps.Point(
                faCircle.icon[0] / 2, // width
                faCircle.icon[1] // height
            ),
            strokeWeight: 3,
            strokeColor: "#333",
            scale: 0.055,
            scaledSize: new google.maps.Size(50, 50),
        }}

    />
}

export default TravelUrbanSharingMarkerPointA;
